import React, { useRef, useEffect } from 'react'

import { useTouch } from './touch-context'

import { cn } from '@/shared/utils'

const BG_VIDEO_DEFAULT = '/images/branding/glassis/bg_default.mp4'
const BG_VIDEO_TOUCH = '/images/branding/glassis/bg_touch.mp4'

const BackgroundVideo = () => {
  const { isTouching } = useTouch()

  return (
    <div className="fixed inset-0 w-full h-full -z-100">
      <video
        src={BG_VIDEO_TOUCH}
        autoPlay
        loop
        muted
        playsInline
        className={cn(
          'fixed inset-0 w-full h-full object-cover -z-10 transition-all duration-500',
          isTouching && '-z-11',
        )}
        onContextMenu={(e) => e.preventDefault()}
      />
      <video
        src={BG_VIDEO_DEFAULT}
        autoPlay
        loop
        muted
        playsInline
        className={cn(
          'fixed inset-0 w-full h-full object-cover -z-10 transition-all duration-500',
          !isTouching && '-z-11',
        )}
        onContextMenu={(e) => e.preventDefault()}
      />
    </div>
  )
}

export default BackgroundVideo
